import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-protocollo-chetogenico',
  templateUrl: './protocollo-chetogenico.component.html',
  styleUrls: ['./protocollo-chetogenico.component.scss']
})
export class ProtocolloChetogenicoComponent implements OnInit {

  pageTitle = "Protocollo Chetogenico | Leone Lifestyle";
  desc = "Protocollo Chetogenico L-Amino"
  shareImg = "masthead-dieta-chetogenica.jpg";

  constructor(private seo: SEOService) {}

  ngOnInit(): void {
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

}
